import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource-variable/manrope';
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/jetbrains-mono';
import '@/index.css';

import { App } from '@/app/App';
import { installPreloadRecovery } from '@/app/preloadRecovery';

installPreloadRecovery();

const container = document.getElementById('root');
if (!container) throw new Error('#root не найден в index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
